export default __webpack_public_path__ + "static/media/img-2.438ea8fc.jpg";